export default class CryptTransferModel {
  ToIban: string = null;
  CryptCurrencyName: string = null;
  CryptNetworkName: string = null;
  Amount: string = null;
  Commission: string = null;
  Description: string = null;

  constructor(obj?: Partial<CryptTransferModel>) {
    if (obj) {
      Object.assign(this, obj)
    }
  }
}